import React from "react"
import Chip from "material-ui/Chip"
import FontIcon from "material-ui/FontIcon"
import IconButton from "material-ui/IconButton"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import autobind from "class-autobind"
import { IChipSelectItem } from "../../models"

interface IProps {
    title: string
    titleStyle: React.CSSProperties
    allData: IChipSelectItem[]
    linkedData: IChipSelectItem[]
    chipStyle: React.CSSProperties
    addButtonStyle: React.CSSProperties
    labelTextForSelect: string
    errorText: string
    readonly?: boolean
    disAllowEmpty?: boolean
    handleAddOne(item: IChipSelectItem): void
    handleDeleteOne(item: IChipSelectItem): void
}
interface IState {
    showSelect: boolean
}

export default class ChipSelect extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            showSelect: false
        }
        autobind(this)
    }

    render() {
        const { title, titleStyle, allData, linkedData, chipStyle, addButtonStyle, labelTextForSelect, errorText } = this.props
        const { showSelect } = this.state

        const dataForSelect = allData.filter(one => {
            const aaa = linkedData.filter(linkedOne => {
                return linkedOne.Id === one.Id
            })
            return aaa.length === 0
        })

        return (
            <div style={{ position: "relative" }}>
                <span style={titleStyle}>{title}</span>
                <div style={{ display: "flex", flexWrap: "wrap", marginTop: -5 }}>
                    {linkedData.map((item, key) =>
                        <Chip
                            key={key}
                            onRequestDelete={this.props.readonly ? null : () => this.props.handleDeleteOne(item)}
                            style={chipStyle}
                        >
                            {item.Name}
                        </Chip>
                    )}
                    {!showSelect && dataForSelect.length > 0 && !this.props.readonly &&
                        <IconButton data-intercom-target={"Btn-ShowSelection"} style={addButtonStyle} onTouchTap={() => this.setState({ showSelect: true })}>
                            <FontIcon className="fa fa-plus-circle" />
                        </IconButton>
                    }
                    {showSelect &&
                        <SelectField
                            data-intercom-target={labelTextForSelect}
                            floatingLabelText={labelTextForSelect}
                            value={null}
                            onChange={(event, key, payload) => {
                                this.setState({ showSelect: false })
                                this.props.handleAddOne(payload)
                            }}
                            style={{ marginTop: -25, width: 265 }}
                            errorText={this.props.errorText}
                            errorStyle={{ position: "absolute", bottom: -10 }}
                        >
                            {!this.props.disAllowEmpty &&
                                <MenuItem value={null} primaryText="" />
                            }
                            {dataForSelect.map((one, key) =>
                                <MenuItem key={key} value={one} primaryText={one.Name} />
                            )}
                        </SelectField>
                    }
                </div>
                {errorText && !showSelect &&
                    <div
                        style={{
                            position: "absolute",
                            top: 57,
                            fontSize: 12,
                            color: "rgb(244, 67, 54)",
                            transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
                            whiteSpace: "nowrap"
                        }}
                    >
                        {errorText}
                    </div>
                }
            </div >
        )
    }
}
